export default __webpack_public_path__ + "static/media/loginScreen.5320701a.svg";